import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  filterField: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  metric: PropTypes.bool,
  isDefault: PropTypes.bool,
  isNew: PropTypes.bool
}).isRequired;
